import React, { useState, useEffect } from "react"
import { LazyLoadImage } from "react-lazy-load-image-component"

import * as s from "./Image.module.scss"

export const Image = ({ data, visibleByDefault }) => {
  const hasCaptionOrTitle = data.caption || data.title || data.description
  const [loaded, setLoaded] = useState(false)

  useEffect(() => {
    if (visibleByDefault) {
      setLoaded(true)
    }
  }, [visibleByDefault])

  return (
    <div className={`${s.Image} ${loaded && s.Image___loaded}`}>
      <div className={s.Image__wrapper}>
        {data.image && (
          <LazyLoadImage
            src={data.image.sourceUrl}
            alt={data.alt || data.altText || data.title || data.caption}
            delayTime={500}
            visibleByDefault={visibleByDefault || false}
            afterLoad={() => {
              setLoaded(true)
            }}
          />
        )}
        {hasCaptionOrTitle && (
          <div
            className={s.CaptionWrapper}
            style={
              data.blockColor
                ? {
                    background: data.blockColor,
                  }
                : {}
            }
          >
            {data.title && <h5>{data.title}</h5>}
            {data.caption && <p>{data.caption}</p>}
            {data.description && <p>{data.description}</p>}
          </div>
        )}
      </div>
    </div>
  )
}
